import { render, staticRenderFns } from "./ServiceEntity.vue?vue&type=template&id=51297c6e&"
import script from "./ServiceEntity.vue?vue&type=script&lang=js&"
export * from "./ServiceEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports